// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"zg-z","itemsContainer":"Ag-z"};